import { useState } from "react";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";
import "./styles.scss";

//@mui imports for drawer

import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import ListSubheader from "@mui/material/ListSubheader";
import Collapse from "@mui/material/Collapse";

import { useLocation } from "@reach/router";

// import ExpandMore from '@mui/icons-material/ExpandMore';
// import ExpandLess from '@mui/icons-material/ExpandLess';

const Mobile = () => {
  const location = useLocation();
  const isSalesCoursePage = location.pathname === "/sales-course/";
  const [openNav, setOpenNav] = useState(false);
  const [openEntryLevel, setOpenEntryLevel] = useState(false);
  const [openResources, setOpenResources] = useState(false);
  const [openFullTime, setOpenFullTime] = useState(false);

  const [selectedIndex, setSelectedIndex] = useState(-1);

  const toggleDrawer = (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    if (openNav) {
      setOpenEntryLevel(false);
      setOpenResources(false);
      setOpenFullTime(false);
      setSelectedIndex(-1);
    }

    setOpenNav(!openNav);
  };

  const handleItemClick = (index) => {
    setSelectedIndex(index);
  };

  console.log(location, "location");

  return (
    <div className="mob-nav-wrap">
      <div className="mob-head-wrap">
        <div
          className="mob-nav-logo"
          aria-hidden="true"
          onClick={() => setOpenNav(!openNav)}
        >
          <img
            src={
              isSalesCoursePage
                ? "https://s3.ap-south-1.amazonaws.com/testconvexstorage.kraftshala.com/test/18d4a409-0f1b-479b-bad9-c100958b83c1/events/banner-upload/14i86ykmm6m78mmxja.png"
                : "https://s3.ap-south-1.amazonaws.com/convexstorage.kraftshala.com/production/453b391a-01f1-4431-a281-8c58470d35bc/events/banner-upload/14i86y23t2m2j1pdca.webp"
            }
            alt="Nav"
            title="Nav"
            placeholder="none"
          />
        </div>
        {!isSalesCoursePage && (
          <div className="mob-head-logo">
            <Link to={"/" + location?.search}>
              <StaticImage
                src="https://s3.ap-south-1.amazonaws.com/convexstorage.kraftshala.com/production/453b391a-01f1-4431-a281-8c58470d35bc/events/banner-upload/14i86y16fv8m1qdwai0.webp"
                alt="Kraftshala"
                title="Kraftshala"
                placeholder="none"
                className="nav-log"
              />
            </Link>
          </div>
        )}

        <div></div>
      </div>

      <Drawer
        anchor="left"
        open={openNav}
        onClose={toggleDrawer}
        PaperProps={{
          sx: {
            "&.MuiDrawer-paper": {
              width: "85%",
              // height: '95%',
              // top: '5%',
              borderTopRightRadius: "15px",
              borderBottomRightRadius: "15px",
            },
          },
        }}
        className="mb-menu-main"
      >
        <div className="mb-menu-header">
          {/* <LazyLoad once>
            <img
              src={}
              loading="lazy" 
            />
          </LazyLoad> */}
          <StaticImage
            src="https://s3.ap-south-1.amazonaws.com/convexstorage.kraftshala.com/production/453b391a-01f1-4431-a281-8c58470d35bc/events/banner-upload/14i86y16fv8m1qf1lhw.webp"
            alt="Kraftshala"
            title="Kraftshala"
            placeholder="none"
            className="nav-log"
          />
          <button className="nav-toggle-btn" onClick={toggleDrawer}>
            {" "}
            ✕{" "}
          </button>
        </div>
        <Divider className="hr-divider" />

        <List>
          {/* ----Programs Start---- */}
          <ListItemButton
            selected={selectedIndex === 1 && openEntryLevel}
            onClick={() => {
              setOpenEntryLevel(!openEntryLevel);
              handleItemClick(1);
            }}
          >
            <ListItemText
              primary="Programs"
              primaryTypographyProps={{
                sx: ParentItemStyles,
              }}
            />
            {openEntryLevel ? (
              <img
                src="https://s3.ap-south-1.amazonaws.com/convexstorage.kraftshala.com/production/453b391a-01f1-4431-a281-8c58470d35bc/events/banner-upload/14i86y16fv8m1qfd402.svg"
                width={"1rem"}
                className="mb-menu-arrow-up"
                loading="lazy"
              />
            ) : (
              <img
                src="https://s3.ap-south-1.amazonaws.com/convexstorage.kraftshala.com/production/453b391a-01f1-4431-a281-8c58470d35bc/events/banner-upload/14i86y16fv8m1qf9n0b.svg"
                width={"1rem"}
                className="mb-menu-arrow-down"
                loading="lazy"
              />
            )}
          </ListItemButton>

          <Collapse in={openEntryLevel} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              <ListItemButton
                selected={selectedIndex === 2 && openFullTime}
                sx={{ pl: 4 }}
                onClick={() => {
                  setOpenFullTime(!openFullTime);
                  handleItemClick(2);
                }}
              >
                <ListItemText
                  primary="Marketing Launchpad"
                  primaryTypographyProps={{
                    sx: {
                      ...ParentItemStyles,
                      fontWeight: 700,
                    },
                  }}
                />
                {openFullTime ? (
                  <img
                    src="https://s3.ap-south-1.amazonaws.com/convexstorage.kraftshala.com/production/453b391a-01f1-4431-a281-8c58470d35bc/events/banner-upload/14i86y16fv8m1qfd402.svg"
                    width={"1rem"}
                    className="mb-menu-arrow-up"
                    loading="lazy"
                  />
                ) : (
                  <img
                    src="https://s3.ap-south-1.amazonaws.com/convexstorage.kraftshala.com/production/453b391a-01f1-4431-a281-8c58470d35bc/events/banner-upload/14i86y16fv8m1qf9n0b.svg"
                    width={"1rem"}
                    className="mb-menu-arrow-down"
                    loading="lazy"
                  />
                )}
              </ListItemButton>
              <Collapse in={openFullTime} timeout="auto" unmountOnExit>
                <ListSubheader sx={SubHeaderStyles}>Full-time</ListSubheader>
                <ListItemButton sx={{ pl: 8 }} onClick={toggleDrawer}>
                  <Link
                    to={
                      "/marketing-launchpad/digital-marketing-course/" +
                      location.search
                    }
                  >
                    <ListItemText
                      primary="Digital Marketing Course"
                      secondary="Online | 22 Weeks"
                      primaryTypographyProps={{
                        sx: ChildItemPriStyles,
                      }}
                      secondaryTypographyProps={{
                        sx: ChildItemSecStyles,
                      }}
                    />
                  </Link>
                </ListItemButton>
                {/* <ListItemButton sx={{ pl: 8 }} onClick={toggleDrawer}>
                  <Link
                    to={"/content-writing-course/" + location?.search}
                  >
                    <ListItemText
                      primary="Content and Social Media Launchpad"
                      secondary="22 weeks | Online"
                      primaryTypographyProps={{
                        sx: ChildItemPriStyles
                      }}
                      secondaryTypographyProps={{
                        sx: ChildItemSecStyles
                      }}
                    />
                  </Link>
                </ListItemButton> */}
                <ListSubheader sx={SubHeaderStyles}>Part-time</ListSubheader>
                <ListItemButton sx={{ pl: 8 }} onClick={toggleDrawer}>
                  <Link
                    to={
                      "/marketing-launchpad/part-time-digital-marketing-course" +
                      location?.search
                    }
                  >
                    <ListItemText
                      primary="Digital Marketing Course - Weekend"
                      secondary="Online | 11 Months"
                      primaryTypographyProps={{
                        sx: ChildItemPriStyles,
                      }}
                      secondaryTypographyProps={{
                        sx: ChildItemSecStyles,
                      }}
                    />
                  </Link>
                </ListItemButton>
                <ListSubheader sx={SubHeaderStyles}>
                  Emerging talent
                </ListSubheader>
                <ListItemButton sx={{ pl: 8 }} onClick={toggleDrawer}>
                  <Link
                    to={
                      "/marketing-launchpad/digital-marketing-course-in-hindi/" +
                      location?.search
                    }
                  >
                    <ListItemText
                      primary="Digital Marketing Course in Hindi                      "
                      secondary="Online | 19 Weeks"
                      primaryTypographyProps={{
                        sx: ChildItemPriStyles,
                      }}
                      secondaryTypographyProps={{
                        sx: ChildItemSecStyles,
                      }}
                    />
                  </Link>
                </ListItemButton>
              </Collapse>

              {/* <ListItemButton sx={{ pl: 4 }} onClick={toggleDrawer}>
                <Link to={"/content-writing-course/" + location?.search}>
                  <ListItemText
                    primary="Content and Social Media Launchpad"
                    primaryTypographyProps={{
                      sx: {
                        ...ParentItemStyles,
                        fontWeight: 700,
                      },
                    }}
                  />
                </Link>
              </ListItemButton> */}
              <ListItemButton sx={{ pl: 4 }} onClick={toggleDrawer}>
                <Link to={"/sales-course/" + location?.search}>
                  <ListItemText
                    primary="PGP in Sales, Marketing and Business Leadership"
                    primaryTypographyProps={{
                      sx: {
                        ...ParentItemStyles,
                        fontWeight: 700,
                      },
                    }}
                  />
                </Link>
                {/* {
                  openPartTime ?
                    <img 
                      src={ArrowDown}
                      width={"1rem"}
                      className="mb-menu-arrow-down" 
                    /> : <img 
                    src={ArrowDown}
                    width={"1rem"}
                    className="mb-menu-arrow-down" 
                  />
                } */}
              </ListItemButton>

              {/* <Collapse in={openPartTime} timeout="auto" unmountOnExit >
                <ListItemButton sx={{ pl: 8 }}>
                  <ListItemText 
                    primary="Digital Media Marketing Specialization" 
                    secondary="32 weeks | Paid Ads | Online"
                  />
                </ListItemButton>
              </Collapse> */}

              <Divider className="hr-divider" />

              {/* <ListItemButton sx={{ pl: 4 }} onClick={toggleDrawer} >
                <Link to={"/industrycreds-experience/" + location?.search}>
                  <ListItemText
                    primary="INDUSTRYCreds™ Certification"
                    primaryTypographyProps={{
                      sx: ChildItemPriStyles
                    }}
                  />
                </Link>
              </ListItemButton> */}

              <ListItemButton sx={{ pl: 4 }} onClick={toggleDrawer}>
                <Link
                  target="_blank"
                  to={"https://placement-reports.kraftshala.com/"}
                >
                  <ListItemText
                    primary="Placement"
                    primaryTypographyProps={{
                      sx: ChildItemPriStyles,
                    }}
                  />
                </Link>
              </ListItemButton>
            </List>
          </Collapse>
          <Divider className="hr-divider" />

          {/* ----Programs End---- */}

          <ListItemButton
            selected={selectedIndex === 3 && openResources}
            onClick={() => {
              setOpenResources(!openResources);
              handleItemClick(3);
            }}
          >
            <ListItemText
              primary="Free Resources"
              primaryTypographyProps={{
                sx: ParentItemStyles,
              }}
            />
            {openResources ? (
              <img
                src="https://s3.ap-south-1.amazonaws.com/convexstorage.kraftshala.com/production/453b391a-01f1-4431-a281-8c58470d35bc/events/banner-upload/14i86y16fv8m1qfd402.svg"
                width={"1rem"}
                className="mb-menu-arrow-up"
                loading="lazy"
              />
            ) : (
              <img
                src="https://s3.ap-south-1.amazonaws.com/convexstorage.kraftshala.com/production/453b391a-01f1-4431-a281-8c58470d35bc/events/banner-upload/14i86y16fv8m1qf9n0b.svg"
                width={"1rem"}
                className="mb-menu-arrow-down"
                loading="lazy"
              />
            )}
          </ListItemButton>
          <Collapse in={openResources} timeout="auto" unmountOnExit>
            <ListItemButton sx={{ pl: 4 }} onClick={toggleDrawer}>
              <Link to={"/kraftshala-live/" + location?.search}>
                <ListItemText
                  primary="Kraftshala LIVE"
                  primaryTypographyProps={{
                    sx: ChildItemPriStyles,
                  }}
                />
              </Link>
            </ListItemButton>
            <ListItemButton sx={{ pl: 4 }} onClick={toggleDrawer}>
              <Link to={"/blog/" + location?.search}>
                <ListItemText
                  primary="Blogs"
                  primaryTypographyProps={{
                    sx: ChildItemPriStyles,
                  }}
                />
              </Link>
            </ListItemButton>
            <ListItemButton sx={{ pl: 4 }} onClick={toggleDrawer}>
              <Link to={"/marketing-glossary/" + location?.search}>
                <ListItemText
                  primary="Marketing Glossary"
                  primaryTypographyProps={{
                    sx: ChildItemPriStyles,
                  }}
                />
              </Link>
            </ListItemButton>
            <ListItemButton sx={{ pl: 4 }} onClick={toggleDrawer}>
              <Link to={"/press-releases/" + location?.search}>
                <ListItemText
                  primary="Press Releases"
                  primaryTypographyProps={{
                    sx: ChildItemPriStyles,
                  }}
                />
              </Link>
            </ListItemButton>
          </Collapse>
          <Divider className="hr-divider" />

          <ListItemButton onClick={toggleDrawer}>
            <Link to={"https://reviews.kraftshala.com/" + location?.search}>
              <ListItemText
                primary="Alumni Connect"
                primaryTypographyProps={{
                  sx: ParentItemStyles,
                }}
              />
            </Link>
          </ListItemButton>
          <Divider className="hr-divider" />

          <ListItemButton onClick={toggleDrawer}>
            <Link to={"/hire-from-us/" + location?.search}>
              <ListItemText
                primary="Hire from us"
                primaryTypographyProps={{
                  sx: ParentItemStyles,
                }}
              />
            </Link>
          </ListItemButton>

          <Divider className="hr-divider" />

          <ListItemButton onClick={toggleDrawer}>
            <Link to={"/kraftshala-careers/" + location?.search}>
              <ListItemText
                primary="Careers"
                primaryTypographyProps={{
                  sx: ParentItemStyles,
                }}
              />
            </Link>
          </ListItemButton>

          <Divider className="hr-divider" />
        </List>
      </Drawer>
    </div>
  );
};

const ParentItemStyles = {
  textTransform: "uppercase",
  letterSpacing: "0.125ch",
  fontWeight: "500",
  fontSize: "0.8em",
};

const ChildItemPriStyles = {
  fontSize: "0.85rem",
  color: "#606060",
};

const ChildItemSecStyles = {
  fontSize: "0.85rem",
  color: "#737373",
};

const SubHeaderStyles = {
  pl: 4,
  lineHeight: "unset",
  fontSize: "0.7em",
  fontWeight: "600",
  color: "black",
  textTransform: "uppercase",
};

export default Mobile;
